import React from 'react'
import styles from './ImageDots.module.css'
function ImageDots({images, selectedImageIndex}) {
  return (
    <div className={styles.ImageDots}>
      {images.map((image, index) => (
        <div key={index} className={styles.dot} onClick={() => selectedImageIndex(index)}></div>
      ))}
    </div>
  )
}

export default ImageDots